import { getSize } from '@/utils/iterable/getSize';
import { reduce } from '@/utils/iterable/reduce';

import { TAXONOMY_PROPERTY } from '@/constants/product';
import { EMPTY } from '@/constants';

export function getAffectingPropertyName({ property = {}}) {
  return getSize(property.affectedBy) > 0
    ? Object.keys(property.affectedBy)[0]
    : undefined;
}

export function getAffectedPropertyName({ property = {}}) {
  return getSize(property.affecting) > 0
    ? property.affecting[0]
    : undefined;
}

export function getFirstValue(value = EMPTY.SET) {
  return value.toList().get(0);
}

export function getPropertyType(property = {}) {
  if (property.text) {
    if ('options' in property) {
      return TAXONOMY_PROPERTY.ALTER;
    }

    return TAXONOMY_PROPERTY.TEXT;
  }

  function reduceAffectedToBool(result, options) {
    return result && getSize(options) === 2;
  }

  if (getSize(property.options) > 0 || getSize(property.affectedBy) > 0) {
    if (property.multiValued) {
      return TAXONOMY_PROPERTY.MULTI;
    }

    if (getSize(property.options) === 2) {
      return TAXONOMY_PROPERTY.BOOL;
    }

    if (getSize(property.options) === 0) {
      const affectedBy = getAffectingPropertyName({ property });

      if (affectedBy && reduce(property.affectedBy[affectedBy], true, reduceAffectedToBool)) {
        return TAXONOMY_PROPERTY.BOOL;
      }
    }

    return TAXONOMY_PROPERTY.SINGLE;
  }

  return TAXONOMY_PROPERTY.CUSTOM;
}
